import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import auth from './auth';

export const Protegerotas=({component:Component, ...rest})=>{
    return(
        <Route {...rest} 
        render={props=>{
                console.log(auth.isAuthenticated())
                if(JSON.parse(auth.isAuthenticated())){
                    return <Component {...props}/>;
        

                }else{
                    return <Redirect
                    to={"/"}
                    />;
                }
                    }
        } />
    )
}